import ModifyPasswordModal from './modify-password-modal.vue'
export default ModifyPasswordModal
